/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkCreateSystemUserResult
 */
export interface BulkCreateSystemUserResult {
    /**
     * 
     * @type {string}
     * @memberof BulkCreateSystemUserResult
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof BulkCreateSystemUserResult
     */
    created: boolean;
    /**
     * 
     * @type {string}
     * @memberof BulkCreateSystemUserResult
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkCreateSystemUserResult
     */
    error?: string;
}

/**
 * Check if a given object implements the BulkCreateSystemUserResult interface.
 */
export function instanceOfBulkCreateSystemUserResult(value: object): value is BulkCreateSystemUserResult {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    return true;
}

export function BulkCreateSystemUserResultFromJSON(json: any): BulkCreateSystemUserResult {
    return BulkCreateSystemUserResultFromJSONTyped(json, false);
}

export function BulkCreateSystemUserResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkCreateSystemUserResult {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'created': json['created'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function BulkCreateSystemUserResultToJSON(json: any): BulkCreateSystemUserResult {
    return BulkCreateSystemUserResultToJSONTyped(json, false);
}

export function BulkCreateSystemUserResultToJSONTyped(value?: BulkCreateSystemUserResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'created': value['created'],
        'userId': value['userId'],
        'error': value['error'],
    };
}

